import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import './store/api/fbConfig';
import { startAuthListener } from './compat/firebaseState';

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';

TimeAgo.addDefaultLocale(en);

startAuthListener();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('React root element #root was not found.');
}

createRoot(rootElement).render(<App />);
